export default __webpack_public_path__ + "static/bodySectionBg-3d299e035545c8062519f2f235bce74a.png";